import { CorporateActionInput } from './corporate-action-input'
import { CorporateActionSecurityGroup } from './corporate-action-security-group'
import { CorporateActionStatus } from './corporate-action-status'

export interface CorporateAction extends CorporateActionInput {
  id: string
  createdDateTime: string
  updatedDateTime: string
  securityGroups: CorporateActionSecurityGroup[]
  status?: CorporateActionStatus
  reflagDateTime?: string
  createdByUserId: number
  deleted: boolean
  needsWork: string
}

export interface CorporateActionTableModel {
  id: string
  type: string
  action?: string
  effectiveDate?: string
  parents?: string
  children?: string
  jira?: string
  status?: string
  parentChild?: ParentChild[]
  needsWork?: string
  forceReflag?: string
}

export interface ParentChild {
  parentVal: string
  childVal?: string
}

export interface CorporateActionModal {
  corporateActionId: string
}

export enum UserActions {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}
